var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InlineSvg',{staticClass:"svg-icon",class:{ active: _vm.active },attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }